// BarcodeStyle.tsx
import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import SliderInput from "@builder/components/general/SliderInput";
import { getValueUnit } from "@builder/components/general/editUtils";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { BarcodeNode } from "@common/build/types";
import { EditableProps } from "../../editableProps";
import "./styles.scss";
import useBarcodeGenerator from "@builder/hooks/useBarcodeGenerator";
import ColorInput from "@builder/components/general/ColorInput";

const BarcodeStyle: React.FC<EditableProps> = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const selectedNode = useAppSelector(getSelectedNode) as BarcodeNode;

    const textType = selectedNode.dynamicData ? "db" : "static";

    useBarcodeGenerator(textType);

    const width = (selectedNode.attr?.style?.width as string) || "100px";
    const height = (selectedNode.attr?.style?.height as string) || "100px";

    const changeWidth = (value: string, unit: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["attr", "style", "width"], value: value + unit }));
    };

    const changeHeight = (value: string, unit: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["attr", "style", "height"], value: value + unit }));
    };

    const backgroundColorCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: ["barcode", "color"], value }));
    };

    return (
        <SidebarCollapse title="Barcode" parent={parent}>
            <SliderInput title="Width" {...getValueUnit(width)} min={5} max={100} callback={changeWidth} />
            <SliderInput title="Height" {...getValueUnit(height)} min={5} max={100} callback={changeHeight} />
            <ColorInput
                title="Color"
                color={selectedNode?.barcode?.color}
                callback={backgroundColorCallback}
                options={{ disableGlobalColors: true }}
            />
        </SidebarCollapse>
    );
};

export default BarcodeStyle;
